(function () {
  if ($('.homepage-mobile-slideshow').length > 0) {
    $('.homepage-desktop-slideshow').addClass('desktop-only');
  }

  var allPanels = $('.accordion > dd').hide();

  $('.accordion > dt > a').click(function () {
    if (!$(this).parent().next().is(":visible")) {
      $(this).find('small.right').html('&#9660;');
      $(this).parent().next().slideDown();
    } else if ($(this).parent().next().is(":visible")) {
      $(this).parent().next().slideUp();
      $(this).parent().next('.accordion small.right').html('&#9668;');
      $(this).next('small.right').html('&#9668;');
      if ($(this).find('small.right').html('&#9660;')) {
        $(this).find('small.right').html('&#9668;');
      } else if ($(this).find('small.right').html('&#9668;')) {
        $(this).find('small.right').html('&#9660;');
      }
    }
    return false;
  });

  if ($('.add_to_cart').length > 0) {
    let cartBtn = document.getElementsByClassName('add_to_cart');
    Array.from(cartBtn).forEach(function (button) {
      button.addEventListener('click', function () {
        gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-8968598/invmedia/solde000+standard'
        });
      })
    })
  }

  $(document).one('scroll', function () {
    load_deferred_images('defer-load');
    load_deferred_images('secondary');
  })
})();

function load_deferred_images(selector) {
  var imgDefer = $('img.' + selector);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('data-src')) {
      imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('data-src'));
    }
  }
}

window.onload = function () {
  setTimeout(
    function () {
      if (window.location.hash.indexOf("rewards") > -1) {
        window.scroll($("h2:contains('REWARDS')").position().left, $("h2:contains('REWARDS')").position().top);
      }
    }, 100);
}

// Contact Modal Vars
var container = document.getElementById('shopify-section-contact-template');
var modal = document.querySelectorAll('.contact-form-modal')[0];
var contactBtn = document.querySelector('.contact-modal-trigger');
var closeTriggers = document.querySelector('.close-modal, #shopify-section-contact-template');

// accessibility - footer accordion
(function($) {
  $('.footer_menu h6').click(function(e) {
      var footerAccordionTitle = $(e.currentTarget);
      if (footerAccordionTitle.attr('aria-expanded') === 'true') {
        $(this).attr('aria-expanded', 'false');
      } else {
        $(this).attr('aria-expanded', 'true');
      }
    });
})(jQuery);

// accessibility - product page options
$('.swatch input:checked').next('div').attr('aria-selected','true');
$('.swatch .swatch-element').click(function(e) {
  var productSwatch = $(e.currentTarget);
  // first, clear all selected states
  // then, set the one selected option as true
  $('.swatch .swatch-element').attr('aria-selected','false');
  $(productSwatch).attr('aria-selected','true');
});
  
// product page info accordion
(function($) {
  var allPanels = $('.product-accordion div.product-accordion-content').hide();
  $('.product-accordion-title').click(function(e) {
      var productAccordionTitle = $(e.currentTarget);
      allPanels.stop().slideUp(200);
      $(this).next('div.product-accordion-content').stop().slideToggle(300);
      $(this).toggleClass('active');

      // first, clear all expanded
      // then, set the open one as expanded after delay
      $('.product-accordion-title').attr('aria-expanded','false');
      setTimeout(function() { $('.product-accordion-title.active').attr('aria-expanded','true'); }, 300);
      
      $('.product-accordion-title').not(this).removeClass('active');
      e.preventDefault();
      if (is_touch_device() || $(window).width() <= 798) {
        $("html, body").animate({
          scrollTop: $('.product-accordion').offset().top - 150
         }, 300);
      };
    });
})(jQuery);